/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{1B724B7C-EDB6-43BF-BC85-E5FB25179787}",
  "sitecoreApiHost": "https://www.apiwebstore.org/",
  "jssAppName": "webstore",
  "coveoAccessToken": "xx4ad653a7-23e9-4d24-9a39-b6a0742d799d",
  "coveoOrganizationId": "americanpetroleuminstituteproductionafn6944o",
  "coveoFarmName": "",
  "coveoSearchHub": "Webstore",
  "coveoQueryPipeline": "API Webstore",
  "coveoSubscriptionPipeline": "API Webstore Subscription",
  "coveoSubscriptionProductSource": "@source==Webstore",
  "coveoSubscriptionProductFilter": "((@producttype==\\\"Standard\\\" @productcode==[[@productcode] @accountnumber==__ACCOUNTNUMBER__ @source==Webstore-Account]) OR (@producttype==\\\"Standard\\\" @industrysegment @industrysegment==[[@productcode] @accountnumber==__ACCOUNTNUMBER__ @source==Webstore-Account]) OR (@producttype==\\\"Datasheet\\\" @producttype==[[@productcode] @accountnumber==__ACCOUNTNUMBER__ @source==Webstore-Account]))",
  "subscriptionKey": "517959424cce40f0b63e32ae80c1c0a8",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/sitecore/api/graph/edge",
  "webstoreVersion": "2024.04.9.16.12",
  "graphQLEndpoint": "https://www.apiwebstore.org//sitecore/api/graph/edge"
};